export interface currencyInterface {
  language?: string;
  style?: string;
  currency?: string;
  value: number;
}

export function currencyFormat({
  language = 'pt-BR',
  style = 'currency',
  currency = 'BRL',
  value,
}: currencyInterface) {
  if (Number.isNaN(value)) {
    return '';
  }
  return new Intl.NumberFormat(language, { style, currency }).format(value);
}

export function numberFormat({ language = 'pt-BR', value }: currencyInterface) {
  return new Intl.NumberFormat(language).format(value);
}
